import clsx from 'clsx'
import React, { useEffect, useRef } from 'react'

import { noop } from '../utils'
import styles from './style.module.scss'

interface Props {
  onMultiClickTrigger?: () => void
  numOfClicks?: number
  clickTimeoutMs?: number
  testNameSpace?: string
}

const DEFAULT_NUM_OF_CLICKS = 3
const DEFAULT_TIMEOUT_MS = 3000

export const MultiClickZone: React.FC<Props> = ({
  onMultiClickTrigger = noop,
  numOfClicks = DEFAULT_NUM_OF_CLICKS,
  clickTimeoutMs = DEFAULT_TIMEOUT_MS,
  testNameSpace = '',
}) => {
  const clickCount = useRef(0)
  const timeoutRef = useRef<NodeJS.Timeout | undefined>()
  const containerStyling = clsx(styles.container)

  const onClickHandler = (): void => {
    clickCount.current += 1

    if (clickCount.current === numOfClicks) {
      onMultiClickTrigger()
      clickCount.current = 0
      clearTimeout(timeoutRef.current)
      return
    }

    clearTimeout(timeoutRef.current)

    timeoutRef.current = setTimeout(() => {
      clickCount.current = 0
    }, clickTimeoutMs)
  }

  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current)
    }
  }, [])

  return <div {...(testNameSpace.length > 0 && { 'data-testid': `${testNameSpace}-multi-zone` })} className={containerStyling} onClick={onClickHandler}></div>
}
